var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconResetLight = function SvgIconResetLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_reset_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.402 13.842 5.387-5.885 1.622 1.486-5.4 5.9a1.117 1.117 0 0 1-.038.04v.001s-.002.005-.001.016c0 .01.004.022.008.03l.007.011.019.015 6.1 5.1-1.412 1.688-6.092-5.094c-.954-.773-1.174-2.31-.2-3.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.918 19.894c-3.492-5.343-10.027-7.287-15.772-5.336l.708 2.083c4.854-1.648 10.316.006 13.225 4.46l.006.009c3.46 5.19 2.005 12.308-3.195 15.775-5.2 3.466-12.31 2.093-15.77-3.188l-.005-.007c-2.915-4.373-2.369-10.119 1.002-13.853l-1.634-1.474c-4.029 4.464-4.683 11.316-1.2 16.543 4.14 6.317 12.628 7.942 18.827 3.81 6.199-4.133 7.945-12.612 3.808-18.822Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_reset_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 8)",
    d: "M0 0h27.2v33H0z"
  })))));
};
export default SvgIconResetLight;